import { examTypeBrandingData } from '@ils/examType/brandingData.js';
import type { ExamType } from '@ils/static/enums.js';

export const getLogo = (logoType: 'small' | 'big', brand: ExamType | 'platform' = 'platform') => {
  return examTypeBrandingData[brand].logos[logoType];
};

export const getLogoForExamType = (logoType: 'small' | 'big', examType: ExamType) => {
  return examTypeBrandingData[examType].logos[logoType];
};
